import { TTask } from 'types/task';

import { TTaskCategory } from "@components/tasks/common/types";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LastIdStore } from "@pages/lastIdStore";
import { imagePicker } from "@utils/imagePicker";
import { Row, Col, Avatar, Button } from "antd";
import { useNavigate } from "react-router-dom";

type Props = {
    data: TTaskCategory & { tasks: Array<TTask>; categories: Array<TTaskCategory> },
    selectList: Array<{ id: number; name: string }>,
    route: string,
    handleCategoryClick: (select: boolean, id: number, name: string) => void,
    noNavigation?: boolean
}

function TaskCategoryCard({
    data,
    selectList,
    route,
    handleCategoryClick,
    noNavigation = false,
}: Props) {
    const navigate = useNavigate();

    return (
        <Row onClick={() => handleCategoryClick(false, data.id, data.name)}>
            <Col>
                <Avatar
                    className="avatar"
                    src={imagePicker({picture: data.picture})}
                />
            </Col>
            <Col>
                <Row>
                    <Col>
                        <h3 className="title">{data.name}</h3>
                    </Col>
                    <Col>
                        <h3
                            className="quantity"
                            onClick={() => {
                                if (noNavigation) return;
                                LastIdStore.setLastTaskCategoryId(data.id);
                                navigate(route);
                            }}
                        >
                            {'(' +
                            data.categories.length +
                            '/' +
                            data.task_count +
                            ')'}
                        </h3>
                    </Col>
                </Row>
            </Col>
            <Col className="select-button">
                <Button
                    icon={<FontAwesomeIcon icon={faCheck} />}
                    onClick={(e) => {
                        e.stopPropagation();
                        handleCategoryClick(true, data.id, data.name);
                    }}
                    shape="circle"
                    type={
                        selectList.find((sli) => sli.id == data.id)
                            ? 'primary'
                            : 'default'
                    }
                />
            </Col>
        </Row>
    )
};

export { TaskCategoryCard };